import { useContext } from 'react';
import { BarraFederataContext } from '../context/barra-federata.context';

export const useBarraFederata = () => useContext(BarraFederataContext);
